import { IChartWorker } from '../workers/common/chart.worker.interface';

/**
 * ChartFactory: factory which process chart configurations.
 */
export class ChartFactory {
	/**
	 * @description createChart: factory's main entry point -- creates the chart.
	 * @param {IChartWorker} worker interface for the chart worker.
	 */
	public createChart(worker: IChartWorker): void {
		worker.transformData();
		worker.initializeChart();
	}
}
